import axiosConfig from "./axiosConfig";

const configPeer = {
  host: "xpertvisio.fr",
  port: 9000,
  path: "/webrtc",
  secure: true,
  config: {
    iceServers: [
      { urls: "stun:turn.xpertvisio.fr:3478" },
      { urls: "stun:stun.l.google.com:19302" },
    ],
    // Optimisations pour Safari iOS et gestion audio
    sdpSemantics: "unified-plan",
    bundlePolicy: "max-bundle",
    rtcpMuxPolicy: "require",
    iceCandidatePoolSize: 10,
    // Priorité aux codecs audio optimisés
    codecPreferences: {
      audio: ["opus", "PCMU", "PCMA"],
    },
  },
};

// TURN credentials come from the API, never from the bundle. Without them the
// call still runs over STUN.
export const getPeerConfig = async (token) => {
  try {
    const { data } = await axiosConfig("webrtc/ice-servers", {
      data: token ? { token } : {},
    });
    if (data.success) {
      return {
        ...configPeer,
        config: {
          ...configPeer.config,
          iceServers: [...configPeer.config.iceServers, ...data.iceServers],
        },
      };
    }
  } catch (err) {
    console.error("ice-servers", err);
  }
  return configPeer;
};
